import { useTheme } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { Small } from 'components/Typography';
import { CircleDollarSign, Coffee, FileText, Home, User } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const menuItems = [
  {
    icon: <Home size={25} />,
    selectedIcon: <Home size={25} />,
    title: '메인',
    url: '/naver/callmetellme/main-2',
  },
  {
    icon: <CircleDollarSign size={25} />,
    selectedIcon: <CircleDollarSign size={25} />,
    title: '지원금',
    url: '/naver/callmetellme/jiwongum',
  },
  {
    icon: <Coffee size={25} />,
    selectedIcon: <Coffee size={25} />,
    title: '커뮤니티',
    url: '/naver/callmetellme/community',
  },
  {
    icon: <FileText size={25} />,
    selectedIcon: <FileText size={25} />,
    title: '회사소개',
    url: '/naver/callmetellme/main-1',
  },
  {
    icon: <User size={25} />,
    selectedIcon: <User size={25} />,
    title: '마이페이지',
    url: '/naver/callmetellme/mypage',
  },
];

export default function CallmeTellmeBottomBar() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);

  // Update selected menu item based on current location
  useEffect(() => {
    const currentIndex = menuItems.findIndex(item => {
      // For community, check if path starts with the URL
      if (item.url === '/naver/callmetellme/community') {
        return location.pathname.startsWith(item.url);
      }
      // For other items, check exact match
      return item.url === location.pathname;
    });
    setSelectedMenuItem(currentIndex !== -1 ? currentIndex : null);
  }, [location.pathname]);

  const handleMenuItemClick = (index, url) => {
    navigate(url);
  };

  return (
    <AppBar
      position="fixed"
      style={{
        backgroundColor: '#fff',
        top: 'auto',
        bottom: 0,
        borderTopRightRadius: '24px',
        borderTopLeftRadius: '24px',
      }}
    >
      <Toolbar sx={{ padding: 0, paddingBottom: '4px' }}>
        <Box
          display="flex"
          justifyContent="space-around"
          alignItems="flex-end"
          width="100%"
        >
          {menuItems.map((item, index) => (
            <Box
              key={index}
              onClick={() => handleMenuItemClick(index, item.url)}
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
            >
              <IconButton sx={{ paddingBottom: '20px' }}>
                <div
                  style={{
                    color:
                      selectedMenuItem === index
                        ? theme.palette.primary.mainBlue
                        : theme.palette.primary.greytxt,
                  }}
                >
                  {selectedMenuItem === index ? item.selectedIcon : item.icon}
                </div>
              </IconButton>
              <Small
                color={
                  selectedMenuItem === index
                    ? theme.palette.primary.mainBlue
                    : theme.palette.primary.greytxt
                }
                sx={{ fontSize: '11px', position: 'absolute', bottom: 4.5 }}
              >
                {item.title}
              </Small>
            </Box>
          ))}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
